import { render, staticRenderFns } from "./FooterSpNavigationTravel.vue?vue&type=template&id=d3617096&scoped=true"
import script from "./FooterSpNavigationTravel.vue?vue&type=script&lang=js"
export * from "./FooterSpNavigationTravel.vue?vue&type=script&lang=js"
import style0 from "./FooterSpNavigationTravel.vue?vue&type=style&index=0&id=d3617096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3617096",
  null
  
)

export default component.exports